var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"main_view"}},[_c('Toolbar'),(_vm.$store.getters.isLogged)?_c('Viewer'):_vm._e(),_c('PopUp')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }